const isMobile = window.matchMedia("only screen and (max-width: 1100px)").matches;
var drawer = function () {

	/**
	 * Element.closest() polyfill
	 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
	 */
	if (!Element.prototype.closest) {
		if (!Element.prototype.matches) {
			Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
		}
		Element.prototype.closest = function (s) {
			var el = this;
			var ancestor = this;
			if (!document.documentElement.contains(el)) return null;
			do {
				if (ancestor.matches(s)) return ancestor;
				ancestor = ancestor.parentElement;
			} while (ancestor !== null);
			return null;
		};
	}


	//
	// Settings
	//
	var settings = {
		speedOpen: 50,
		speedClose: 350,
		activeClass: 'is-active',
		visibleClass: 'is-visible',
		selectorTarget: '[data-drawer-target]',
		selectorTrigger: '[data-drawer-trigger]',
		selectorClose: '[data-drawer-close]',

	};


	//
	// Methods
	//

	// Toggle accessibility
	var toggleccessibility = function (event) {
		if (event.getAttribute('aria-expanded') === 'true') {
			event.setAttribute('aria-expanded', false);
		} else {
			event.setAttribute('aria-expanded', true);
		}
	};

	// Open Drawer
	var openDrawer = function (trigger) {

		// Find target
		var target = document.getElementById(trigger.getAttribute('aria-controls'));

		// Make it active
		target.classList.add(settings.activeClass);

		// Make body overflow hidden so it's not scrollable
		document.documentElement.style.overflow = 'hidden';
		if (!isMobile) {
			document.documentElement.style.paddingRight = '10px';
		}
		document.documentElement.classList.add('drawer-open');

		// Toggle accessibility
		toggleccessibility(trigger);

		// Make it visible
		setTimeout(function () {
			target.classList.add(settings.visibleClass);
		}, settings.speedOpen);

		trigger.setAttribute('data-drawer-close', true);
		trigger.removeAttribute('data-drawer-trigger', true);

	};

	// Close Drawer
	var closeDrawer = function (event) {

		// Find target
		// var closestParent = event.closest(settings.selectorTarget),
		// 	childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');

		var closestParent = document.querySelector(settings.selectorTarget),
			childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');

		// Make it not visible
		closestParent.classList.remove(settings.visibleClass);

		// Remove body overflow hidden
		document.documentElement.classList.remove('drawer-open');
		setTimeout(function () {
			if (!isMobile) {
				document.documentElement.style.paddingRight = '0';
			}
			document.documentElement.style.overflow = '';
		}, 300);

		// Toggle accessibility
		toggleccessibility(childrenTrigger);

		// Make it not active
		setTimeout(function () {
			closestParent.classList.remove(settings.activeClass);
		}, settings.speedClose);

		event.setAttribute('data-drawer-trigger', true);
		event.removeAttribute('data-drawer-close', true);

	};

	// Click Handler
	var clickHandler = function (event) {

		// Find elements
		var toggle = event.target,
			open = toggle.closest(settings.selectorTrigger),
			close = toggle.closest(settings.selectorClose);

		// Open drawer when the open button is clicked
		if (open) {
			openDrawer(open);
		}

		// Close drawer when the close button (or overlay area) is clicked
		if (close) {
			closeDrawer(close);
		}

		// Prevent default link behavior
		if (open || close) {
			event.preventDefault();
		}

	};

	// Keydown Handler, handle Escape button
	var keydownHandler = function (event) {

		if (event.key === 'Escape' || event.keyCode === 27) {

			// Find all possible drawers
			var drawers = document.querySelectorAll(settings.selectorTarget),
				i;

			// Find active drawers and close them when escape is clicked
			for (i = 0; i < drawers.length; ++i) {
				if (drawers[i].classList.contains(settings.activeClass)) {
					closeDrawer(drawers[i]);
				}
			}

		}

	};


	//
	// Inits & Event Listeners
	//
	document.addEventListener('click', clickHandler, false);
	document.addEventListener('keydown', keydownHandler, false);


};

drawer();